export default function MobileFilterTrigger() {
	// Cache frequently accessed elements
	const openFilters = document.querySelector('.js-open-filters');
	const filterContent = openFilters ? openFilters.nextElementSibling : null;

	// Attach event listeners
	if (openFilters && filterContent) {
		openFilters.addEventListener('click', handleFiltersToggle);
	}

	const filtersContainer = document.querySelector('.js-filters-container');
	if (filtersContainer) {
		filtersContainer.addEventListener('change', handleFilterChange);
	}
	
	function handleFiltersToggle(e) {
		e.preventDefault();
		
		const openFilters = e.target;
		const filterContent = openFilters.nextElementSibling;
		
		document.dispatchEvent(new Event("trigger_filters"));

		if (openFilters.textContent === 'Close Filters') {
			openFilters.textContent = 'Open Filters';
		} else {
			openFilters.textContent = 'Close Filters';
		}
		filterContent.classList.toggle('u-hide');
	}

	function handleFilterChange(e) {
		const filter = e.target;
		const form = filter.closest('form');
		if (form) {
			form.submit();
		}
	}
}
